import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { InAppNotificationsEffects } from 'src/app/in-app-notifications/store/effects/in-app-notifications.effects';
import { inAppNotificationsReducer } from 'src/app/in-app-notifications/store/reducers/in-app-notifications.reducer';
import { inAppNotificationsFeatureKey } from 'src/app/in-app-notifications/store/selectors/in-app-notifications.selectors';

export const provideInAppNotificationsStore = (): EnvironmentProviders[] => [
    provideState(inAppNotificationsFeatureKey, inAppNotificationsReducer),
    provideEffects([InAppNotificationsEffects])
];
